/** 导航栏 */
import SvgBack from './svg/back.svg';
import SvgMore from './svg/more.svg';
import SvgClose from './svg/close.svg';

let domNavBar: HTMLElement;
let domTitle: HTMLElement;
let domBack: HTMLElement;

const getSvgDom = (svg: string) => {
  const div = document.createElement('div');
  div.innerHTML = svg;
  return div.firstElementChild as HTMLElement;
};

/** 页面增加导航栏 */
export const addNavBar = () => {
  domNavBar = document.createElement('div');
  domNavBar.className = 'ovopark-nav';
  const style = document.createElement('style');
  style.innerHTML = `
    body {
      display: flex;
      flex-direction: column;
      height: 100vh;
    }
    .ovopark-nav {
      position: relative;
      z-index: 9;
      display: flex;
      flex-shrink: 0;
      align-items: center;
      height: 11.73333vw;
      padding: 11.73333vw 1.6vw 0 2.13333vw;
      color: #000;
      background-color: #fff;
      box-shadow: rgba(0, 0, 0, 0.3) 0 0 0.8vw -1px;
      box-sizing: content-box;
      user-select: none;
    }
    .ovopark-nav ~ div[id*=app] {
      flex: 1;
      min-height: 0 !important;
      overflow: auto;
    }
    .ovopark-nav * {
      box-sizing: border-box;
    }
    .ovopark-nav svg {
      flex-shrink: 0;
      width: 6.4vw;
      height: 6.4vw;
    }
    .ovopark-nav__back {
      flex-shrink: 0;
      width: 6.4vw;
      height: 6.4vw;
      font-size: 0;
    }
    .ovopark-nav__title {
      flex: 1;
      margin: 0 4.26667vw 0 20.53333vw;
      overflow: hidden;
      font-size: 4.53333vw;
      font-weight: 600;
      text-align: center;
      text-overflow: ellipsis;
      word-break: break-all;
      white-space: nowrap;
    }
    .ovopark-nav__right {
      position: relative;
      display: flex;
      flex-shrink: 0;
      align-items: center;
      justify-content: space-between;
      width: 23.2vw;
      height: 8.53333vw;
      padding: 0 2.66667vw;
      border: 0.5px solid rgba(151, 151, 151, 0.2);
      border-radius: 8.53333vw;
    }
    .ovopark-nav__right::after {
      position: absolute;
      left: 50%;
      display: block;
      width: 0.5px;
      height: 4.93333vw;
      content: "";
      background-color: rgba(0, 0, 0, 0.2);
    }
  `;
  domNavBar.appendChild(style);

  domBack = document.createElement('div');
  domBack.className = 'ovopark-nav__back';
  if (!/webview\/h5base|\/web\/oauth/.test(location.href)) {
    // h5base和oauth页面，不需要返回
    domBack.innerHTML = SvgBack;
  }

  domTitle = document.createElement('div');
  domTitle.className = 'ovopark-nav__title';
  domTitle.innerText = document.title;

  const svgMore = getSvgDom(SvgMore);
  const svgClose = getSvgDom(SvgClose);
  const domRight = document.createElement('div');
  domRight.className = 'ovopark-nav__right';
  domRight.appendChild(svgMore);
  domRight.appendChild(svgClose);

  domNavBar.appendChild(domBack);
  domNavBar.appendChild(domTitle);
  domNavBar.appendChild(domRight);

  // 如果body有子元素，将导航栏插入到第一个子元素之前，否则添加到body
  const bodyChildren = document.body.children;
  if (bodyChildren.length > 0) {
    document.body.insertBefore(domNavBar, bodyChildren[0]);
  } else {
    document.body.appendChild(domNavBar);
  }

  domBack.addEventListener('click', () => {
    if (window.wdzCustomNavBack) {
      // 自定义返回事件
      window.wdzCustomNavBack();
    } else {
      window.history.back();
    }
  });
  svgClose.addEventListener('click', () => {
    if (window.wdzCustomNavClose) {
      // 自定义关闭事件
      window.wdzCustomNavClose();
    } else if (window.ovopark?.closePage) {
      window.ovopark.closePage();
    } else {
      window.opener = null;
      window.close();
    }
  });
};

/**
 * 设置导航栏标题
 * @param title 标题
 */
export const setNavTitle = (title: string) => {
  domTitle && title && (domTitle.innerText = title);
};

/**
 * 设置导航栏可见性
 * @param show 是否显示
 */
export const setNavVisible = (show: boolean) => {
  domNavBar && (domNavBar.style.display = show ? 'flex' : 'none');
};

/**
 * 获取导航栏
 */
export const getNavBarDom = () => {
  return domNavBar;
};
